import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import './style.sass';
import { BtnWhats } from 'components/Buttons/BtnWhats'
import { BtnFloatMenu } from 'components/Buttons/floatMenu'

export default function HeaderMobileCredito(props) {
    const { 
        type,
        title,
        logo,
        btnTypeR,
        action
    } = props;

    const history = useHistory();

    // type = back / close
    const regresar = () => {
        history.goBack(-1);
    };

    return (
        <>
            {type === "back" &&
                <div className="contentClose">
                    <div className="btn close" onClick={regresar} ></div>
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : btnTypeR ===  "floatMenu"
                            ? <BtnFloatMenu />
                            : null
                    }
                </div>
            }
            {type === "backFull" &&
                <div className="contentClose fullContainer">
                    <div className="btn close" onClick={regresar} ></div>
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : btnTypeR ===  "floatMenu"
                            ? <BtnFloatMenu />
                            : null
                    }
                </div>
            }
            {type === "backFullAction" &&
                <div className={title ? "contentClose fullContainer" : "contentCloseX" }>
                    {title &&
                        <div className="btn close" onClick={action} ></div>
                    }
                    <div className="title">
                        {title &&
                            <p >{title}</p>
                        }
                        {logo &&
                            <img src={logo} alt="logo-sears"></img>
                        }
                    </div>
                    {logo &&
                            
                        <div className="btn closeX" onClick={action} ></div>
                    }
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : null
                    }
                </div>
            }
            {type === "backPayment" &&
                <div className="contentClose">
                    <div className="btn close" onClick={action} ></div>
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : null
                    }
                </div>
            }
            

            {(type === "close" && title) &&
                <div className="contentCloseX">
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    <div className="btn closeX" onClick={regresar} ></div>
                </div>
            }

            {(type === "close" && logo) &&
                <div className="contentCloseX">
                    <div className="title">
                        <img src={logo} alt="logo-sears"></img>
                    </div>
                    <div className="btn closeX" onClick={regresar} ></div>
                </div>
            }

        </>
    )
}